module.exports = __webpack_public_path__ + "img/Extra380.214a91e3.png";